import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../image/right-arrow-forward.png';
import _imports_1 from '../image/occ_r_img.png';
var _hoisted_1 = {
  class: "occupation_box"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "occ_title"
}, "Career Development", -1);

var _hoisted_3 = {
  class: "occ_content container"
};
var _hoisted_4 = {
  class: "occ_left_box col-lg-7 col-md-7 col-sm-12 col-xs-12"
};

var _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"occ_l_line\"></div><div class=\"occ_l_text_01\">At Tenacia, we warmly welcome exceptional talent who share our philosophy, passion, and collaborative spirit to join our team. </div><div class=\"occ_l_text_02\">Whether your expertise lies in early research, drug development, marketing, product sales, or other key functional areas, we are committed to offering a competitive and comprehensive compensation package along with a strong platform for career advancement. As our company continues to grow rapidly, we will consistently provide vast opportunities for professional development and growth. </div><div class=\"occ_l_text_03\">Welcome to submit your resume: <span class=\"occ_mail\">HR@tenacia.com</span></div>", 4);

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" Learn More ");

var _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "occ_l_arrow"
}, null, -1);

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "occ_right_box col-lg-5 col-md-5 col-sm-12 col-xs-12"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "occ_r_img"
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
    class: "occ_l_btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.jumpDetail && $setup.jumpDetail.apply($setup, arguments);
    })
  }, _hoisted_11)]), _hoisted_12])]);
}